import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-pic",
  "use": "foquz-icon-pic-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-pic\"><path d=\"M5 14H1V1h13v4M9.991 9.991L13 8 5 5l3 8 1.991-3.009zm0 0L14 14\" stroke=\"#73808D\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol